// extracted by mini-css-extract-plugin
module.exports = {"tick":"style_tick__efl0k","axisLabel":"style_axisLabel__335Tq","barLabel":"style_barLabel__UF3_s","legendTick":"style_legendTick__2f7KS","legendLabel":"style_legendLabel__sqTVt"};